export function Logo({ height = 40, showSub = true, className = "" }) {
  return (
    <img
      src="/ddp-logo.png"
      alt="DDP · Datos · Decisión · Posición"
      style={{ height, width: "auto", display: "block" }}
      className={className}
      data-testid="ddp-logo"
    />
  );
}

export function Wordmark({ size = 34 }) {
  return (
    <span className="ddp-brand" style={{ fontSize: size }} data-testid="ddp-wordmark">
      DDP
    </span>
  );
}
